export const catalogosRoutesMap = {
  productoServicio: {
    path: '/catalogo/productoServicio',
    name: 'Productos / Servicios',
  },
  metodoPago: {
    path: '/catalogo/metodoPago',
    name: 'Métodos de Pago',
  },
}
